module.exports = __webpack_public_path__ + "img/home3.5608a936.png";